import Form_4 from './Form_4-redux';

export default Form_4;
